import { Typography } from "@mui/material";
import { ICandidate } from "../domain/candidate";
import { useMemo } from "react";
import { LightBox } from "./light-box";

interface CandidateImageProps {
    candidate: ICandidate;
}
export const CandidateImage = ({ candidate }: CandidateImageProps) => {
    const { image_lg_url, image_sm_url } = candidate;

    const image_sm = useMemo(() => {
        return (
            <img style={{ maxWidth: "100%", maxHeight: "100%", border: '1px solid #E8e8e8', borderRadius: 3, objectFit: "contain" }} src={(image_sm_url || image_lg_url) + "s=w400"} />
        )
    }, [image_lg_url, image_sm_url])

    if (!image_lg_url) {
        return image_sm;
    }

    return (<LightBox small={image_sm}>
        <img style={{ maxWidth: "100%", maxHeight: "100%", border: '1px solid #E8e8e8', borderRadius: 3, objectFit: "contain" }} src={image_lg_url + "s=w400"} />
    </LightBox>)
}


interface CandidateNameProps {
    candidate: ICandidate;
}
export const CandidateName = ({ candidate }: CandidateNameProps) => {
    return <Typography>{candidate.label}</Typography>;
};
